"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertingComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AlertingComponent extends a ReactComponent to provide a Confirm Alert, Progress, and Busy indicators
 */
var AlertingComponent = exports.AlertingComponent = /*#__PURE__*/function (_Component) {
  function AlertingComponent() {
    var _this;
    _classCallCheck(this, AlertingComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AlertingComponent, [].concat(args));
    _defineProperty(_this, "_busyCount", 0);
    //number of busy requestors
    _defineProperty(_this, "state", {
      confirmAlert: {
        show: false,
        title: "",
        message: "",
        onConfirm: null,
        titleColor: 'black',
        confirmButtonColor: 'black',
        messageComponent: null,
        onCancel: null
      },
      //State of the alerter for this component
      progressAlert: {
        show: false,
        title: ""
      },
      //State of the alerter for this component
      progressStatus: {
        progressVal: 0,
        primaryMessage: "",
        secondaryMessage: ""
      },
      isBusy: false //true to show the busy indiator
    });
    //-------------------------------- BUSY INDICATOR------------------------------------
    /**
     * Returns a React Component that can be placed at the top of your render() in the subclass. Will show busy indicator 
     * whenever the busy count is above zero.  Default props can be overriden.
     */
    _defineProperty(_this, "getBusyComponent", function () {
      var justify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;
      return _this.state.isBusy ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: justify
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
        size: size,
        style: style
      })) : null;
    });
    //Force the state of the busy component, setting count to one or zero
    _defineProperty(_this, "setBusy", function (isBusy) {
      _this._busyCount = isBusy ? 1 : 0;
      _this.setState({
        isBusy: isBusy
      });
    });
    //Increment busy count, starting the busy if not already started
    _defineProperty(_this, "incrementBusy", function () {
      _this._busyCount += 1;
      _this.setState({
        isBusy: _this._busyCount > 0 ? true : false
      });
    });
    //Decrement busy count, halting the busy if count is zero
    _defineProperty(_this, "decrementBusy", function () {
      _this._busyCount -= 1;
      if (_this._busyCount < 0) _this._busyCount = 0;
      _this.setState({
        isBusy: _this._busyCount > 0 ? true : false
      });
    });
    //-------------------------------- CONFIRM ALERT------------------------------------
    /**
     * Show the confirm alert component, that is added to the render() method as described in getConfirmAlertComponent()
     * The dialog is closed when any button is pressed. 
     * 
     * @param {String} title the title on the alert dialog
     * @param {String} message the message on the alert dialog (ignored if messageComponent is non-null)
     * @param {String} canceButtonText optional text for Cancel button (if null, default is "OK)
     * @param {Function} callback when the Confirm button is pressed (can be null, only if there's no Confirm button)
     * @param {String} confirmButtonText optional text for Confirm button (if null, no Confirm button is rendered, no callback needed)
     * @param {String} titleColor optional, color of the title.  If not provided, color is black
     * @param {String} confirmButtonColor optional, color of the Confirm button.  If not provided, color is black
     * @param {JSX} messageComponent optional, the component to be rendered. If null, just use the message text.
     * @param {Function} callback when the Cancel button is pressed (can be null)
     */
    _defineProperty(_this, "showConfirmAlert", function (title, message) {
      var titleColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'black';
      var cancelButtonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "OK";
      var onConfirm = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var confirmButtonText = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var confirmButtonColor = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'black';
      var messageComponent = arguments.length > 7 ? arguments[7] : undefined;
      var onCancel = arguments.length > 8 ? arguments[8] : undefined;
      _this.setState({
        confirmAlert: {
          show: true,
          title: title,
          message: message,
          cancelButtonText: cancelButtonText,
          onConfirm: onConfirm,
          confirmButtonText: confirmButtonText,
          titleColor: titleColor,
          confirmButtonColor: confirmButtonColor,
          messageComponent: messageComponent,
          onCancel: onCancel
        }
      });
    });
    /**
     * Close the Confirm alert component
     */
    _defineProperty(_this, "closeConfirmAlert", function () {
      _this.setState({
        confirmAlert: {
          show: false,
          onConfirm: null,
          onCancel: null
        }
      }); //don't care about other properties
    });
    //Handle confirm button (or key) pressed
    _defineProperty(_this, "_confirmAlertConfirm", function () {
      var confirmHandler = _this.state.confirmAlert.onConfirm;
      _this.closeConfirmAlert(); //close the dialog
      if (confirmHandler) {
        //call the callback
        confirmHandler();
      }
    });
    //Handle cancel button
    _defineProperty(_this, "_confirmAlertCancel", function () {
      var cancelHandler = _this.state.confirmAlert.onCancel;
      _this.closeConfirmAlert(); //close the dialog
      if (cancelHandler) cancelHandler();
    });
    //Handle key events
    _defineProperty(_this, "_keyDown", function (event) {
      if (_this.state.confirmAlert && _this.state.confirmAlert.show === true) {
        if (event.key === 'Escape') _this._confirmAlertCancel();else if (event.key === 'Enter' && !_this.state.confirmAlert.onConfirm) _this.closeConfirmAlert();else if (event.key === 'Enter') _this._confirmAlertConfirm();
      }
    });
    /**
     * Returns a React Component that can be placed at the top of your render() in the subclass. Will open or close based on
     * showConfirmAlert() call
     */
    _defineProperty(_this, "getConfirmAlertComponent", function () {
      return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
        open: _this.state.confirmAlert.show,
        onClose: _this._confirmAlertCancel
      }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: _this.state.confirmAlert.titleColor
        }
      }, _this.state.confirmAlert.title)), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_core.DialogContentText, null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: 'black'
        }
      }, _this.state.confirmAlert.messageComponent ? _this.state.confirmAlert.messageComponent : _this.state.confirmAlert.message))), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, _this.state.confirmAlert.confirmButtonText ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        variant: "outlined",
        onClick: _this._confirmAlertConfirm,
        style: {
          color: _this.state.confirmAlert.confirmButtonColor
        }
      }, _this.state.confirmAlert.confirmButtonText) : null, _this.state.confirmAlert.cancelButtonText ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        variant: "outlined",
        onClick: _this._confirmAlertCancel
      }, _this.state.confirmAlert.cancelButtonText) : null));
    });
    //-------------------------------- PROGRESS ALERT------------------------------------
    /**
     * Show the progress alert component, that is added to the render() method as described in getProgressAlertComponent()
     * The dialog is closed when cancel button is pressed. 
     * 
     * @param {String} title the title on the dialog
     * @param {String} canceButtonText optional text for Cancel button (Default null, no cancel button)
     * @param {Function} cancelCallback when the Cancel button is pressed (can be null, only if there's no Cancel button)
     * @param {String} titleColor optional, color of the title.  If not provided, color is black
     */
    _defineProperty(_this, "showProgressAlert", function (title) {
      var titleColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'black';
      var initialText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var cancelButtonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var cancelCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      _this.setState({
        progressAlert: {
          show: true,
          title: title,
          cancelCallback: cancelCallback,
          titleColor: titleColor
        },
        progressStatus: {
          progressVal: 0,
          primaryMessage: initialText,
          secondaryMessage: "",
          primaryTextColor: 'black',
          secondaryTextColor: 'black',
          cancelButtonText: cancelButtonText
        }
      });
    });
    /**
     * Update the progress alert component
     * @param {Integer} value from 0 to 100, percent complete
     * @param {String} optional primary text below the progress dialog (use null to leave unchanged)
     * @param {String} optional secondary text below the primary text (use null to leave unchanged)
     * @param {String} optional primary text color (use null to leave unchanged)
     * @param {String} optional secondary text color (use null to leave unchanged)
     * @param {String} cancelButtonText the cancel button text (use null to leave unchanged)
     */
    _defineProperty(_this, "updateProgressAlert", function (progressVal) {
      var primaryMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var secondaryMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var primaryColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var secondaryColor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var cancelButtonText = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var val = progressVal < 0 ? 0 : progressVal;
      if (val > 100) val = 100;
      _this.setState(function (prevState) {
        return {
          progressStatus: {
            progressVal: val,
            primaryMessage: primaryMessage ? primaryMessage : prevState.progressStatus.primaryMessage,
            secondaryMessage: secondaryMessage ? secondaryMessage : prevState.progressStatus.secondaryMessage,
            primaryTextColor: primaryColor ? primaryColor : prevState.progressStatus.primaryTextColor,
            secondaryTextColor: secondaryColor ? secondaryColor : prevState.progressStatus.secondaryTextColor,
            cancelButtonText: cancelButtonText
          }
        };
      });
    });
    _defineProperty(_this, "closeProgressAlert", function () {
      _this.setState({
        progressAlert: {
          show: false
        }
      }); //don't care about other properties
    });
    //Call the cancel callback, and close the alert
    _defineProperty(_this, "cancelProgressAlert", function () {
      if (_this.state.progressAlert.cancelCallback) {
        _this.state.progressAlert.cancelCallback();
      }
      _this.closeProgressAlert();
    });
    /**
     * Returns a React Component that can be placed at the top of your render() in the subclass. Will open or close based on
     * showProgressAlert() call
     */
    _defineProperty(_this, "getProgressAlertComponent", function () {
      var maxWidth = window.innerWidth * 0.66; //two thirds the window, up to 650
      if (maxWidth > 650) maxWidth = 650;
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        open: _this.state.progressAlert.show,
        anchorOrigin: {
          vertical: 'center',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'center',
          horizontal: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
        style: {
          margin: 20,
          width: maxWidth
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
        variant: "subtitle1",
        style: {
          fontWeight: 'bold',
          color: _this.state.progressAlert.titleColor
        }
      }, _this.state.progressAlert.title), /*#__PURE__*/_react["default"].createElement(LinearProgressWithLabel, {
        variant: "determinate",
        value: _this.state.progressStatus.progressVal
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: _this.state.progressStatus.primaryTextColor,
          marginTop: 10
        }
      }, _this.state.progressStatus.primaryMessage)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: _this.state.progressStatus.secondaryTextColor
        }
      }, _this.state.progressStatus.secondaryMessage), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
        container: true,
        alignItems: "flex-start",
        justify: "flex-end",
        direction: "row",
        style: {
          paddingTop: 20
        }
      }, _this.state.progressStatus.cancelButtonText ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        variant: "outlined",
        onClick: _this.cancelProgressAlert,
        style: {
          marginRight: 20
        }
      }, _this.state.progressStatus.cancelButtonText) : null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        disabled: _this.state.progressStatus.progressVal < 100,
        variant: "outlined",
        onClick: _this.closeProgressAlert
      }, "Done"))));
    });
    return _this;
  }
  _inherits(AlertingComponent, _Component);
  return _createClass(AlertingComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("keydown", this._keyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keydown", this._keyDown);
    }
  }]);
}(_react.Component); //---------------------- PRIVATE -------------------------------
function LinearProgressWithLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    width: "100%",
    mr: 1
  }, /*#__PURE__*/_react["default"].createElement(_core.LinearProgress, _extends({
    variant: "determinate"
  }, props))), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    minWidth: 35
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "".concat(Math.round(props.value), "%"))));
}